import { render, staticRenderFns } from "./profile-contracts.vue?vue&type=template&id=0d01c374&scoped=true&"
import script from "./profile-contracts.vue?vue&type=script&lang=ts&"
export * from "./profile-contracts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d01c374",
  null
  
)

export default component.exports